import React from 'react';

export const Blinker = () => {
  return (
    <span className="blink">|</span>
  );
};